export class Util {
  // this timeout can be awaited
  public static timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
}
